import { apiGet, apiPost, apiDelete, apiPatch } from '../../utils/api';
import { config } from '../../config/app-config';
import { isAuthenticated } from '../auth';
import { showErrorNotification, showSuccessNotification } from '../../utils/notifications';

const TRANSLIT_MAP = {
    'а':'a','б':'b','в':'v','г':'h','ґ':'g','д':'d','е':'e','є':'ie','ж':'zh',
    'з':'z','и':'y','і':'i','ї':'i','й':'i','к':'k','л':'l','м':'m','н':'n',
    'о':'o','п':'p','р':'r','с':'s','т':'t','у':'u','ф':'f','х':'kh','ц':'ts',
    'ч':'ch','ш':'sh','щ':'shch','ь':'','ю':'iu','я':'ia',
};

function toSlug(text) {
    return text.toLowerCase()
        .split('').map(c => TRANSLIT_MAP[c] ?? c).join('')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-|-$/g, '');
}

const PAGE_TYPES = {
    diagnostic: {
        label: 'Діагностика',
        listPath: () => config.api.paths.diagnostics,
        createPath: config.api.paths.diagnostics,
        deletePath: (id) => `${config.api.paths.diagnostics}/${id}`,
        publishPath: (id) => `${config.api.paths.diagnostics}/${id}/publish`,
        detailUrl: (slug) => `/diagnostic/${slug}`,
    },
    news: {
        label: 'Новини',
        listPath: () => `${config.api.paths.news}?limit=200&exclude_cases=true`,
        createPath: config.api.paths.news,
        deletePath: (id) => `${config.api.paths.news}/${id}`,
        publishPath: (id) => `${config.api.paths.news}/${id}/publish`,
        detailUrl: (slug) => `/news/${slug}`,
    },
    case: {
        label: 'Кейси',
        listPath: () => `${config.api.paths.cases}?limit=200`,
        createPath: config.api.paths.cases,
        deletePath: (id) => `${config.api.paths.cases}/${id}`,
        publishPath: (id) => `${config.api.paths.cases}/${id}/publish`,
        detailUrl: (slug) => `/case/${slug}`,
        createSlugPrefix: 'case-',
    },
    course: {
        label: 'Курси',
        listPath: () => `${config.api.paths.courses}?limit=200`,
        createPath: config.api.paths.courses,
        deletePath: (id) => `${config.api.paths.courses}/${id}`,
        publishPath: (id) => `${config.api.paths.courses}/${id}/publish`,
        detailUrl: (slug) => `/course/${slug}`,
    },
    vacancy: {
        label: 'Вакансії',
        listPath: () => `${config.api.paths.vacancies}?limit=200`,
        createPath: config.api.paths.vacancies,
        deletePath: (id) => `${config.api.paths.vacancies}/${id}`,
        publishPath: (id) => `${config.api.paths.vacancies}/${id}/publish`,
        detailUrl: (slug) => `/vacancy/${slug}`,
    },
};

export function initPageManager() {
    if (!isAuthenticated()) return;
    _addCreatePageButton();
}

function _addCreatePageButton() {
    if (document.getElementById('create-page-button')) return;

    const btn = document.createElement('button');
    btn.id = 'create-page-button';
    btn.textContent = '+ Сторінка';

    Object.assign(btn.style, {
        position: 'fixed',
        bottom: '20px',
        right: '190px',
        padding: '12px 20px',
        backgroundColor: '#1976D2',
        color: 'white',
        border: 'none',
        borderRadius: '4px',
        cursor: 'pointer',
        boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
        zIndex: '1000',
        fontWeight: '500',
        fontSize: '14px',
        transition: 'background-color 0.3s',
    });

    btn.addEventListener('mouseover', () => { btn.style.backgroundColor = '#1565C0'; });
    btn.addEventListener('mouseout', () => { btn.style.backgroundColor = '#1976D2'; });
    btn.addEventListener('click', _openCreateModal);

    document.body.appendChild(btn);
}

export async function openPagesListModal(initialType = 'diagnostic') {
    const overlay = document.createElement('div');
    overlay.className = 'edit-modal';

    const typeOptions = Object.entries(PAGE_TYPES)
        .map(([val, t]) => `<option value="${val}"${val === initialType ? ' selected' : ''}>${t.label}</option>`)
        .join('');

    overlay.innerHTML = `
        <div class="modal-content" style="max-width:680px;padding:24px;max-height:85vh;display:flex;flex-direction:column;overflow:hidden;">
            <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:16px;flex-shrink:0;">
                <div style="display:flex;align-items:center;gap:12px;">
                    <h3 style="margin:0;font-size:16px;font-weight:600;">Сторінки</h3>
                    <select id="pm-type-filter" style="padding:6px 10px;border:1px solid #ddd;border-radius:6px;font-size:13px;">
                        ${typeOptions}
                    </select>
                </div>
                <button id="pm-create-new" style="padding:8px 14px;background:#1976D2;color:white;border:none;border-radius:6px;cursor:pointer;font-size:13px;font-weight:500;">
                    + Нова сторінка
                </button>
            </div>

            <div style="overflow:auto;flex:1;">
                <table style="width:100%;border-collapse:collapse;font-size:13px;">
                    <thead>
                        <tr style="border-bottom:2px solid #eee;">
                            <th style="text-align:left;padding:8px 10px;font-weight:600;opacity:.7;position:sticky;top:0;background:white;">Назва</th>
                            <th style="text-align:left;padding:8px 10px;font-weight:600;opacity:.7;position:sticky;top:0;background:white;">Slug</th>
                            <th style="text-align:left;padding:8px 10px;font-weight:600;opacity:.7;position:sticky;top:0;background:white;">Статус</th>
                            <th style="text-align:left;padding:8px 10px;font-weight:600;opacity:.7;position:sticky;top:0;background:white;">Картка</th>
                            <th style="text-align:left;padding:8px 10px;font-weight:600;opacity:.7;position:sticky;top:0;background:white;"></th>
                        </tr>
                    </thead>
                    <tbody id="pm-tbody"><tr><td colspan="5" style="text-align:center;padding:20px;opacity:.5;">Завантаження...</td></tr></tbody>
                </table>
            </div>

            <div style="margin-top:16px;text-align:right;flex-shrink:0;">
                <button class="cancel-btn">Закрити</button>
            </div>
        </div>
    `;

    const style = document.createElement('style');
    style.textContent = `
        .pages-table__row:hover { background:#f5f7ff; }
        .pages-table__cell { padding:10px;border-bottom:1px solid #f0f0f0;vertical-align:middle; }
        .pages-table__cell--slug { font-family:monospace;font-size:12px;opacity:.7; }
        .pages-table__cell--actions { white-space:nowrap; }
        .page-status-dot { display:inline-block;width:8px;height:8px;border-radius:50%;margin-right:6px;vertical-align:middle; }
        .page-status-dot--published { background:#4caf50; }
        .page-status-dot--draft { background:#bbb; }
        .pm-delete-btn { background:none;border:none;cursor:pointer;color:#bbb;padding:3px;border-radius:4px;vertical-align:middle;transition:color .15s; }
        .pm-delete-btn:hover { color:#d32f2f; }
        .pm-delete-btn:disabled { opacity:.4;cursor:default; }
    `;
    document.head.appendChild(style);
    document.body.appendChild(overlay);

    function close() { overlay.remove(); style.remove(); }

    const buildRows = (list, type) => list.length
        ? list.map(p => `
            <tr class="pages-table__row" data-page-id="${p.id}" data-page-title="${p.title}" data-type="${type}" data-status="${p.status}">
                <td class="pages-table__cell">
                    <span class="page-status-dot page-status-dot--${p.status}"></span>
                    ${p.title}
                </td>
                <td class="pages-table__cell pages-table__cell--slug">${p.slug}</td>
                <td class="pages-table__cell pages-table__cell--status">${p.status === 'published' ? 'Опубліковано' : 'Чернетка'}</td>
                <td class="pages-table__cell pages-table__cell--linked">${p.block_id ? '✓' : '—'}</td>
                <td class="pages-table__cell pages-table__cell--actions">
                    <button class="pm-publish-btn" data-id="${p.id}" data-type="${type}" data-status="${p.status}"
                        style="padding:3px 8px;border-radius:4px;border:1px solid;cursor:pointer;font-size:12px;font-weight:500;margin-right:8px;
                               ${p.status === 'published'
                                   ? 'background:#fff3e0;color:#e65100;border-color:#ffcc80;'
                                   : 'background:#e8f5e9;color:#2e7d32;border-color:#a5d6a7;'}">
                        ${p.status === 'published' ? 'Зняти' : 'Опублікувати'}
                    </button>
                    <a href="${PAGE_TYPES[type].detailUrl(p.slug)}" target="_blank"
                       style="color:#1976D2;text-decoration:none;font-weight:500;font-size:13px;margin-right:8px;">
                        Відкрити →
                    </a>
                    <button class="pm-delete-btn" data-id="${p.id}" data-type="${type}" title="Видалити сторінку">
                        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/>
                            <path fill-rule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/>
                        </svg>
                    </button>
                </td>
            </tr>
        `).join('')
        : `<tr><td colspan="5" style="text-align:center;padding:20px;opacity:.5;">Немає створених сторінок</td></tr>`;

    async function loadPages(type) {
        const tbody = overlay.querySelector('#pm-tbody');
        tbody.innerHTML = `<tr><td colspan="5" style="text-align:center;padding:20px;opacity:.5;">Завантаження...</td></tr>`;

        try {
            const typeDef = PAGE_TYPES[type];
            let pages = await apiGet(typeDef.listPath(), { auth: false }) || [];
            if (typeDef.listFilter) pages = typeDef.listFilter(pages);
            tbody.innerHTML = buildRows(pages, type);
        } catch {
            tbody.innerHTML = `<tr><td colspan="5" style="text-align:center;padding:20px;color:#d32f2f;">Помилка завантаження</td></tr>`;
        }
    }

    const typeSelect = overlay.querySelector('#pm-type-filter');
    await loadPages(typeSelect.value);

    typeSelect.addEventListener('change', () => loadPages(typeSelect.value));

    overlay.querySelector('.cancel-btn').addEventListener('click', close);
    overlay.addEventListener('click', (e) => { if (e.target === overlay) close(); });

    overlay.querySelector('#pm-create-new').addEventListener('click', () => {
        close();
        _openCreateModal(typeSelect.value);
    });

    overlay.querySelector('#pm-tbody').addEventListener('click', async (e) => {
        const publishBtn = e.target.closest('.pm-publish-btn');
        if (publishBtn) {
            const id = publishBtn.dataset.id;
            const type = publishBtn.dataset.type;
            const currentStatus = publishBtn.dataset.status;
            publishBtn.disabled = true;
            publishBtn.textContent = '...';
            try {
                const result = await apiPost(PAGE_TYPES[type].publishPath(id));
                if (result?.status) {
                    const row = publishBtn.closest('.pages-table__row');
                    const newStatus = result.status;
                    row.dataset.status = newStatus;
                    publishBtn.dataset.status = newStatus;

                    const dot = row.querySelector('.page-status-dot');
                    dot.className = `page-status-dot page-status-dot--${newStatus}`;

                    const statusCell = row.querySelector('.pages-table__cell--status');
                    statusCell.textContent = newStatus === 'published' ? 'Опубліковано' : 'Чернетка';

                    if (newStatus === 'published') {
                        publishBtn.textContent = 'Зняти';
                        publishBtn.style.background = '#fff3e0';
                        publishBtn.style.color = '#e65100';
                        publishBtn.style.borderColor = '#ffcc80';
                    } else {
                        publishBtn.textContent = 'Опублікувати';
                        publishBtn.style.background = '#e8f5e9';
                        publishBtn.style.color = '#2e7d32';
                        publishBtn.style.borderColor = '#a5d6a7';
                    }
                    publishBtn.disabled = false;
                    showSuccessNotification(newStatus === 'published' ? 'Опубліковано' : 'Знято з публікації');
                }
            } catch {
                showErrorNotification('Помилка зміни статусу');
                publishBtn.disabled = false;
                publishBtn.textContent = currentStatus === 'published' ? 'Зняти' : 'Опублікувати';
            }
            return;
        }

        const btn = e.target.closest('.pm-delete-btn');
        if (!btn) return;

        const row = btn.closest('.pages-table__row');
        const title = row.dataset.pageTitle;
        const id = btn.dataset.id;
        const type = btn.dataset.type;

        if (!confirm(`Видалити сторінку "${title}"?\n\nЦю дію неможливо скасувати.`)) return;

        btn.disabled = true;
        try {
            await apiDelete(PAGE_TYPES[type].deletePath(id));
            row.remove();
            showSuccessNotification(`Сторінку "${title}" видалено`);

            const tbody = overlay.querySelector('#pm-tbody');
            if (!tbody.querySelector('.pages-table__row')) {
                tbody.innerHTML = `<tr><td colspan="5" style="text-align:center;padding:20px;opacity:.5;">Немає створених сторінок</td></tr>`;
            }
        } catch {
            showErrorNotification('Помилка при видаленні сторінки');
            btn.disabled = false;
        }
    });
}

function _openCreateModal(defaultType = 'diagnostic') {
    const overlay = document.createElement('div');
    overlay.className = 'edit-modal';

    const typeOptions = Object.entries(PAGE_TYPES)
        .map(([val, t]) => `<option value="${val}"${val === defaultType ? ' selected' : ''}>${t.label}</option>`)
        .join('');

    overlay.innerHTML = `
        <div class="modal-content" style="max-width:400px;">
            <h3 style="margin:0 0 16px;font-size:16px;font-weight:600;">Створити сторінку</h3>

            <div style="margin-bottom:14px;">
                <label style="display:block;margin-bottom:6px;font-size:13px;font-weight:500;">Тип сторінки</label>
                <select id="cpm-type" style="width:100%;padding:10px;border:1px solid #ccc;border-radius:8px;font-size:14px;">
                    ${typeOptions}
                </select>
            </div>

            <div style="margin-bottom:14px;">
                <label style="display:block;margin-bottom:6px;font-size:13px;font-weight:500;">Назва сторінки</label>
                <input id="cpm-title" type="text" placeholder="Наприклад: Гістологічне дослідження"
                       style="width:100%;padding:10px;border:1px solid #ccc;border-radius:8px;font-size:14px;box-sizing:border-box;">
            </div>

            <div style="margin-bottom:4px;">
                <label style="display:flex;justify-content:space-between;margin-bottom:6px;font-size:13px;font-weight:500;">
                    <span>URL (slug)</span>
                    <span id="cpm-slug-auto" style="font-weight:400;font-size:12px;color:#1976D2;cursor:pointer;">авто</span>
                </label>
                <input id="cpm-slug" type="text" placeholder="histolohichne-doslidzhennia"
                       style="width:100%;padding:10px;border:1px solid #ccc;border-radius:8px;font-size:14px;box-sizing:border-box;font-family:monospace;">
            </div>

            <div class="buttons" style="margin-top:20px;">
                <button class="cancel-btn">Скасувати</button>
                <button class="save-btn">Створити</button>
            </div>
        </div>
    `;

    document.body.appendChild(overlay);

    const titleInput = overlay.querySelector('#cpm-title');
    const slugInput = overlay.querySelector('#cpm-slug');
    const slugAutoBtn = overlay.querySelector('#cpm-slug-auto');
    const typeSelect = overlay.querySelector('#cpm-type');
    const saveBtn = overlay.querySelector('.save-btn');
    const cancelBtn = overlay.querySelector('.cancel-btn');

    let slugManuallyEdited = false;

    titleInput.focus();

    titleInput.addEventListener('input', () => {
        if (!slugManuallyEdited) {
            const prefix = PAGE_TYPES[typeSelect.value].createSlugPrefix || '';
            slugInput.value = prefix + toSlug(titleInput.value);
        }
    });

    typeSelect.addEventListener('change', () => {
        if (!slugManuallyEdited) {
            const prefix = PAGE_TYPES[typeSelect.value].createSlugPrefix || '';
            slugInput.value = prefix + toSlug(titleInput.value);
        }
    });

    slugInput.addEventListener('input', () => {
        slugManuallyEdited = slugInput.value !== '';
        slugAutoBtn.style.opacity = slugManuallyEdited ? '0.4' : '1';
    });

    slugAutoBtn.addEventListener('click', () => {
        slugManuallyEdited = false;
        slugAutoBtn.style.opacity = '1';
        const prefix = PAGE_TYPES[typeSelect.value].createSlugPrefix || '';
        slugInput.value = prefix + toSlug(titleInput.value);
        slugInput.style.borderColor = '';
    });

    function close() { overlay.remove(); }

    cancelBtn.addEventListener('click', close);
    overlay.addEventListener('click', (e) => { if (e.target === overlay) close(); });
    titleInput.addEventListener('keydown', (e) => { if (e.key === 'Enter') slugInput.focus(); });
    slugInput.addEventListener('keydown', (e) => { if (e.key === 'Enter') saveBtn.click(); });

    saveBtn.addEventListener('click', async () => {
        const title = titleInput.value.trim();
        if (!title) {
            titleInput.style.borderColor = '#e53935';
            titleInput.focus();
            return;
        }

        const type = typeSelect.value;
        const typeDef = PAGE_TYPES[type];

        const prefix = typeDef.createSlugPrefix || '';
        const rawSlug = slugInput.value.trim() || prefix + toSlug(title);
        const slug = rawSlug
            .toLowerCase()
            .replace(/[^a-z0-9-]+/g, '-')
            .replace(/^-|-$/g, '');

        if (!slug) {
            slugInput.style.borderColor = '#e53935';
            slugInput.focus();
            return;
        }

        saveBtn.disabled = true;
        saveBtn.textContent = 'Створюється...';

        try {
            const body = { title, slug };

            const result = await apiPost(typeDef.createPath, body);

            if (result?.id) {
                showSuccessNotification(`Сторінку "${result.title}" створено`);
                close();
            } else {
                showErrorNotification(result?.detail || 'Помилка при створенні');
                saveBtn.disabled = false;
                saveBtn.textContent = 'Створити';
            }
        } catch {
            showErrorNotification('Помилка при створенні сторінки');
            saveBtn.disabled = false;
            saveBtn.textContent = 'Створити';
        }
    });
}
